<script setup>
import { computed } from 'vue'
import { useMeta } from '@/stores/meta.js'

/** A connection role's reverse (D-202): what the other side is, one of the dictionary's rows (itself when the same both ways). */
const props = defineProps({ modelValue: { type: String, default: null }, row: { type: Object, default: null }, context: { type: Object, default: null }, disabled: Boolean })
const emit = defineEmits(['update:modelValue'])
const meta = useMeta()
const options = computed(() => (props.context?.entries || []).filter((e) => e.key).map((e) => ({ value: e.key, label: meta.localized(e.label) || e.key })))
</script>

<template>
  <select class="input py-1 text-sm" :value="modelValue || row?.key || ''" :disabled="disabled" @change="emit('update:modelValue', $event.target.value || null)">
    <option v-for="o in options" :key="o.value" :value="o.value">{{ o.label }}</option>
  </select>
</template>
